import React from 'react';
import localStorage from 'local-storage';
import SortInput from '../sort-input/SortInput';
import Dropdown from '../dropdown/Dropdown';
import { formatListTitleCount } from 'shared/utils';

export class Pagination extends React.Component {
	render() {
		if (!this.props.pagination) {
			return null;
		}
		let totalPages = 1;
		let pages = [];
		let currentPage = 1;
		let currentLimit = 10;
		let showOptions = [10, 25, 50, 100];
		const step = 5;
		if (this.props.pagination.totalResults > this.props.pagination.limit) {
			currentPage = this.props.pagination.page;
			currentLimit = this.props.pagination.limit;
			totalPages = Math.ceil(this.props.pagination.totalResults / currentLimit);
		}
		// show all pages
		if (totalPages < step) {
			pages = this.addPages(1, totalPages);
		} else if (currentPage - step / 2 <= 0) {
			// FIRST - step
			pages = this.addPages(1, step);
		} else if (currentPage + step / 2 >= totalPages) {
			// step - LAST
			pages = this.addPages(totalPages + 1 - step, totalPages);
		} else {
			// step (page in middle)
			pages = this.addPages(
				Math.ceil(currentPage - step / 2),
				Math.ceil(currentPage + step / 2) - 1
			);
		}

		return (
			<div className="ATS-Pagination">
				<div className="ats-pagination-list">
					{this.props.totalResults != null || !this.props.hideLimitSelect ? (
						<div className="pagination-leading">
							{this.props.totalResults != null ? (
								<p className="results-count">
									{formatListTitleCount(this.props.totalResults)} results
								</p>
							) : null}
							{this.props.totalResults != null &&
							!this.props.hideLimitSelect ? (
								<span className="pagination-divider" aria-hidden="true" />
							) : null}
							{this.props.hideLimitSelect ? null : (
								<div className="size-controls">
									<p className="page-size">Show</p>
									<Dropdown
										value={{
											label: this.props.pagination.limit,
											value: this.props.pagination.limit
										}}
										options={showOptions.map(option => ({
											label: option,
											value: option
										}))}
										onChange={option =>
											this.handlePaginationChange(currentPage, option.value)
										}
									/>
									<p className="page-size">per page</p>
								</div>
							)}
						</div>
					) : null}
					{this.props.customButton ? this.props.customButton : null}
					{this.props.sortOptions ? (
						<SortInput
							options={this.props.sortOptions}
							handleSort={this.props.onSortChange}
							iconOnly={this.props.sortIconOnly !== false}
						/>
					) : null}
					{this.props.hidePageControls ? null : (
						<div
							className={`page-controls ${!this.props.sortOptions && !this.props.customButton ? 'ml-auto' : ''}`}>
							<p
								onClick={() => {
									if (pages.length > 1 && currentPage !== 1) {
										this.handlePaginationChange(currentPage - 1, currentLimit);
									}
								}}
								className={
									'pg-control go-back ' +
									(pages.length > 1 && currentPage !== 1 ? '' : 'is-disabled')
								}>
								<i className="fas fa-angle-left" />
							</p>
							<div className="current-page">
								<p className="page">{currentPage}</p>
								<p>of {totalPages}</p>
							</div>
							<p
								onClick={() => {
									if (pages.length > 1 && currentPage < totalPages) {
										this.handlePaginationChange(currentPage + 1, currentLimit);
									}
								}}
								className={
									'pg-control go-forward go-last ' +
									(pages.length > 1 && currentPage < totalPages
										? ''
										: 'is-disabled')
								}>
								<i className="fas fa-angle-right" />
							</p>
						</div>
					)}
				</div>
			</div>
		);
	}

	addPages(from, to) {
		let pages = [];
		for (let i = from; i <= to; i++) {
			pages.push(i);
		}
		return pages;
	}

	handlePaginationChange(page, limit) {
		if (this.props.pagination.totalResults <= limit) {
			page = 1;
		}
		if (this.props.onPaginationChange) {
			localStorage.set('paginationLimit', limit);
			this.props.onPaginationChange(page, limit);
		}
	}
}
